import extend from 'lodash/extend';

import AddressConstants from 'app/shared/constants/AddressConstants';
import AnalyticsConstants from 'app/shared/constants/AnalyticsConstants';
import BuildingAmenitiesConstants from 'app/shared/constants/BuildingAmenitiesConstants';
import DispatchConstants from 'app/shared/constants/DispatchConstants';
import ExtensionsConstants from 'app/shared/constants/ExtensionsConstants';
import KeyCodeConstants from 'app/shared/constants/KeyCodeConstants';
import LeadConstants from 'app/shared/constants/LeadConstants';
import PropertiesConstants from 'app/shared/constants/PropertiesConstants';
import ModalConstants from 'app/shared/constants/ModalConstants';
import PropertyConstants from 'app/shared/constants/PropertyConstants';
import QueryConstants from 'app/shared/constants/QueryConstants';
import ReviewsConstants from 'app/shared/constants/ReviewsConstants';
import StringConstants from 'app/shared/constants/StringConstants';
import LoadingConstants from 'app/shared/constants/LoadingConstants';

const Constants = extend(
    AddressConstants,
    AnalyticsConstants,
    BuildingAmenitiesConstants,
    DispatchConstants,
    ExtensionsConstants,
    KeyCodeConstants,
    LeadConstants,
    ModalConstants,
    PropertiesConstants,
    PropertyConstants,
    QueryConstants,
    ReviewsConstants,
    StringConstants,
    LoadingConstants,
);

export default Constants;
